/* GRIZZLY — subscribe / one-time selector for a SINGLE BAR pdp.
 * ---------------------------------------------------------------------------
 * Replaces Payeo's `subscription_widget` app block plus the hand-written
 * override that sat beside it in `custom_liquid_nH83kW`. Payeo rendered the
 * radios; the override watched `input[name="selling_plan"]` and swapped the CTA.
 * With Payeo gone the radios never appeared, the override's `initPayeo()` polled
 * `#aioc_subscription_widget` forever, and the PDP quietly became one-time only.
 *
 * ── the rule this whole file exists to enforce ──────────────────────────────
 *
 * **A single bar can NEVER be added to the cart as a subscription.** There is no
 * such product: a subscription is a BOX, priced by size, and a lone bar with a
 * subscription property would be a line nothing downstream can price, pick or
 * renew. So the subscribe option is not a purchase option at all — it is a
 * signpost to /pages/build-a-box.
 *
 * That is why the guard is not one click handler. A click listener alone is
 * defeated by Enter in the quantity field, by a theme that submits the form
 * itself, and by any other script that calls submit(). All three doors are shut:
 *
 *   1. `click`  on the add-to-cart controls, capture phase
 *   2. `submit` on the product form, capture phase
 *   3. `FormData` on the product form — belt and braces, so even a fetch-based
 *      add-to-cart that bypasses both events cannot carry a selling plan
 *
 * ── what it deliberately keeps from the old override ────────────────────────
 *
 * The copy, because customers have seen it: `לבניית מנוי` when subscribing,
 * `הוסף לעגלה` otherwise. The quantity picker still hides on subscribe — you
 * are not buying N of anything, you are going to build a box.
 */
(function () {
  'use strict';

  if (window.__grzSinglePdpSubInit) return;
  window.__grzSinglePdpSubInit = true;

  var CFG = window.GRZ_PDP_SINGLE_SUB || {};
  if (CFG.enabled === false) return;

  var TARGET = CFG.buildUrl || '/pages/build-a-box';
  /* 2026-10-24 sitewide sale (snippets/grz-sale.liquid): one-time at the 10% price; the subscription is shown at
     20% - it is a signpost to build-a-box, where the first box IS 20% off (founder). Display only. */
  var SALE_S = window.GRZ_SALE;
  var PATH_HANDLE = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];
  var SALE = !!(SALE_S && SALE_S.has(CFG.handle || PATH_HANDLE));
  function oneShow() { var o = Number(CFG.onePrice || 0); return SALE ? SALE_S.one(o) : o; }
  function subShow() { return SALE ? SALE_S.barFirst(Number(CFG.onePrice || 0)) : Number(CFG.subPrice || 0); }
  var CTA_SUB = 'לבניית מנוי';
  var CTA_ONE = 'הוסף לעגלה';
  /* Default ON. A cold landing on a bar should see the subscription first —
     that was true under Payeo and is the entire point of the signpost. */
  var state = { active: CFG.defaultSubscribe !== false };

  function money(agorot) {
    var n = (agorot / 100).toFixed(2).replace(/\.00$/, '');
    return '₪' + n;
  }

  function productForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  /* Every control that can start an add-to-cart, including the sticky bar. */
  function atcControls() {
    return document.querySelectorAll(
      '.main-product-atc, .sticky-atc, button[name="add"], .product-form__submit',
    );
  }

  function goBuild() {
    window.location.href = TARGET;
  }

  // ── the three doors ───────────────────────────────────────────────────────

  document.addEventListener(
    'click',
    function (e) {
      if (!state.active) return;
      if (e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var el = e.target && e.target.closest
        ? e.target.closest('.main-product-atc, .sticky-atc, button[name="add"], .product-form__submit')
        : null;
      if (!el) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      goBuild();
    },
    true,
  );

  document.addEventListener(
    'submit',
    function (e) {
      if (!state.active) return;
      var form = e.target;
      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      goBuild();
    },
    true,
  );

  /* The last door. A theme that adds to cart with fetch(new FormData(form))
     never fires submit, so the two listeners above would not see it. This
     cannot redirect — it is not a user gesture — but it CAN make sure the
     request that goes out is a plain one-time line rather than a subscription
     the rest of the system cannot honour. */
  if (window.FormData) {
    var Orig = window.FormData;
    function Patched(formEl) {
      var fd = new Orig(formEl);
      if (!formEl || !formEl.matches || !formEl.matches('form[action*="/cart/add"]')) return fd;
      fd.delete('selling_plan');
      return fd;
    }
    Patched.prototype = Orig.prototype;
    window.FormData = Patched;
  }

  // ── the CTA, the quantity picker, and the radios ──────────────────────────

  /* WRITE ONLY WHEN IT DIFFERS.
     This is watched by a MutationObserver on document.body, so an
     unconditional write is an infinite loop: write -> mutation -> observer ->
     write. That locked the tab on the first version of this file; the page
     served fine and the browser hung, which reads as "the page doesn't load". */
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  /* Keep the headline price honest about which option is selected.
   *
   * The theme HAS a price updater - updateThemePrices() in the PDP template -
   * but it reads its numbers from APPSTLE selectors
   * (.appstle_one_time_details_wrapper .appstle_subscription_amount). Appstle
   * was the subscription app two generations ago: before Payeo, before our own
   * engine. Those elements have not existed for a long time, so the function
   * hits `if (!price) return;` and bails silently on every change. The headline
   * has been frozen at the one-time price ever since, while the widget beside
   * it showed the subscription price. Two prices on one screen, one of them
   * wrong, is the same class of problem as the 375 incident.
   *
   * This widget already knows both numbers, so it says so itself rather than
   * reviving the dead path.
   */
  function applyPrice() {
    var agorot = state.active ? subShow() : oneShow();
    if (!agorot) return;
    var text = money(agorot);

    document.querySelectorAll(
      '.product-page-price .price__regular .price-item--regular,' +
      '.product-page-price .price-item--sale.price-item--last,' +
      '.sticky-atc__price .price__regular .price-item--regular,' +
      '.sticky-atc__price .price-item--sale.price-item--last'
    ).forEach(function (el) {
      /* Never touch the struck-through compare-at: it is the anchor, not the price. */
      if (el.closest('.price__compare-price')) return;
      setText(el, text);
    });

    /* On subscription the one-time price becomes the anchor, so the strike-through
       earns its place. On one-time there is nothing to compare against and it must
       go, or the page shows a saving nobody is getting. */
    var one = Number(CFG.onePrice || 0);
    document.querySelectorAll('.product-page-price .price__compare-price, .sticky-atc__price .price__compare-price')
      .forEach(function (el) {
        var inner = el.querySelector('.price-item--regular') || el;
        if ((state.active || SALE) && one > agorot) { setText(inner, money(one)); el.style.display = ''; }
        else { el.style.display = 'none'; }
      });
    document.querySelectorAll('.product-page-price .price, .sticky-atc__price .price')
      .forEach(function (el) { el.classList.toggle('price--on-sale', (state.active || SALE) && one > agorot); });

    /* Finish the badge's sentence.
     *
     * The theme renders it from settings.sale_badge_text ("תחסכו [percentage]")
     * and fills [percentage] from compare_at_price. This product has none, so it
     * rendered as a bare "תחסכו" with no number - which reads as a bug, and did,
     * the moment price--on-sale above made it visible.
     *
     * The label is read back from whatever the setting produced rather than
     * hardcoded here, so editing sale_badge_text in the theme still works. Cached
     * on the node because this runs on every change and would otherwise append
     * the number again each time. */
    var pct = one > agorot ? Math.round(((one - agorot) / one) * 100) : 0;
    document.querySelectorAll('.product-page-price .price__badge-sale, .sticky-atc__price .price__badge-sale')
      .forEach(function (el) {
        var t = el.querySelector('.nowrap') || el;
        if (!t.hasAttribute('data-grz-base')) {
          t.setAttribute('data-grz-base', (t.textContent || '').replace(/[\d%\s]+$/, ''));
        }
        if ((state.active || SALE) && pct > 0) {
          setText(t, t.getAttribute('data-grz-base') + ' ' + pct + '%');
          el.style.display = '';
        } else {
          el.style.display = 'none';
        }
      });
  }

  function applyCta() {
    var text = state.active ? CTA_SUB : CTA_ONE;
    ['.main-atc__label__text', '.sticky-atc__label__text'].forEach(function (sel) {
      setText(document.querySelector(sel), text);
    });
    // Some themes render the label as the button's own text.
    atcControls().forEach(function (btn) {
      if (!btn.querySelector('.main-atc__label__text, .sticky-atc__label__text')) {
        var span = btn.querySelector('span');
        if (span && !span.children.length) setText(span, text);
      }
    });
    var qty = document.querySelector('.product-form__quantity');
    var want = state.active ? 'none' : '';
    if (qty && qty.style.display !== want) qty.style.display = want;
  }

  function render(mount) {
    var ONE = Number(CFG.onePrice || 0);
    var SUB = Number(CFG.subPrice || 0);
    var months = CFG.months || 3;
    var saving = ONE > SUB && SUB > 0 ? ONE - SUB : 0;
    var pct = saving ? Math.round((saving / ONE) * 100) : 15;

    mount.innerHTML =
      '<div class="grz-sub-opts" role="radiogroup" aria-label="סוג רכישה">' +
        /* HYBRID (founder + three advisors, 2026-09-11): subscription card on TOP
           with the banner; one-time stays PRE-SELECTED below as a clean title +
           price card. The subscription's case is made with true gains only -
           never red ✗s on the default (brain/decisions/2026-09-06-pdp-default-one-time.md). */
        '<label class="grz-sub-opt' + (state.active ? ' is-selected' : '') + '" data-grz-opt="sub">' +
          '<input type="radio" name="grz-single-mode" value="sub"' + (state.active ? ' checked' : '') + '>' +
          '<span class="grz-sub-opt__flag">הכי משתלם</span>' +
          '<span class="grz-sub-opt__head">' +
            '<span class="grz-sub-opt__radio" aria-hidden="true"></span>' +
            '<span class="grz-sub-opt__titles">' +
              '<span class="grz-sub-opt__title">מנוי - תירשמו ותחסכו</span>' +
              '<span class="grz-sub-opt__freq">משלוח כל ' + months + ' חודשים</span>' +
            '</span>' +
            /* The real per-bar price inside a subscription, struck through
               against the one-time price — the same shape the bundle selector
               uses. "15%-" made the reader do the arithmetic, and rendered
               backwards in RTL on top of it. */
            (saving
              ? '<span class="grz-sub-opt__prices">' +
                  '<span class="grz-sub-opt__compare">' + money(ONE) + '</span>' +
                  '<span class="grz-sub-opt__price">' + money(subShow()) + '</span>' +
                '</span>'
              : '') +
          '</span>' +
          '<span class="grz-sub-opt__body">' +
            /* Same two-heading swap as the bundle: the benefits stay on screen
               when one-time is picked, at full strength rather than removed. A list that
               vanishes takes the reason to come back with it. */
            '<span class="grz-sub-opt__benefits-title">' +
              '<span data-bt="sub">הטבות מנוי רבעוני</span>' +
              '<span data-bt="one">מה מפספסים בלי מנוי</span>' +
            '</span>' +
            benefit('בונים מארז ובוחרים ריחות') +
            benefit('משלוח חינם בכל הזמנת מנוי') +
            /* The percentage sits mid-sentence on purpose. Leading with it
               ("15% הנחה…") renders the number on the wrong side under RTL. */
            (SALE ? benefit('<strong>' + SALE_S.sub_first_pct + '% על המארז הראשון</strong>') +
                    benefit(SALE_S.sub_pct + '% על כל מארז אחריו')
                  : benefit('הנחה קבועה של ' + pct + '% בכל משלוח')) +
            benefit('אפשר לדלג, לשנות או לבטל בכל רגע') +
          '</span>' +
        '</label>' +
        '<label class="grz-sub-opt' + (state.active ? '' : ' is-selected') + '" data-grz-opt="one">' +
          '<input type="radio" name="grz-single-mode" value="one"' + (state.active ? '' : ' checked') + '>' +
          '<span class="grz-sub-opt__head">' +
            '<span class="grz-sub-opt__radio" aria-hidden="true"></span>' +
            '<span class="grz-sub-opt__titles">' +
              '<span class="grz-sub-opt__title">רכישה חד פעמית</span>' +
              '<span class="grz-sub-opt__freq">סבון אחד</span>' +
            '</span>' +
            (ONE ? '<span class="grz-sub-opt__prices">' +
                     (SALE ? '<span class="grz-sub-opt__compare">' + money(ONE) + '</span>' : '') +
                     '<span class="grz-sub-opt__price">' + money(oneShow()) + '</span>' +
                   '</span>' : '') +
          '</span>' +
        '</label>' +
      '</div>';

    mount.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'grz-single-mode') return;
      state.active = t.value === 'sub';
      mount.querySelectorAll('.grz-sub-opt').forEach(function (el) {
        el.classList.toggle('is-selected', el.getAttribute('data-grz-opt') === (state.active ? 'sub' : 'one'));
      });
      applyCta();
      applyPrice();
    });
  }

  /* Copied verbatim from grizzly-pdp-subscribe.js. The stylesheet is shared,
     and .grz-sub-opt__benefit/__x style the svg — so a bare span rendered a
     row with no tick at all, which is how the first version shipped. */
  function benefit(text) {
    return '<span class="grz-sub-opt__benefit">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<polyline points="20 6 9 17 4 12"/></svg><span>' + text + '</span></span>';
  }


  function boot() {
    var mount = document.getElementById('grz-single-sub');
    if (!mount) return;
    render(mount);
    applyCta();
    /* The widget defaults to subscription, so the headline is wrong from the
       first paint unless this runs here too. */
    applyPrice();
    /* The theme re-renders the buy buttons on a variant change and when the
       sticky bar appears, which wipes the CTA text. Re-apply rather than fight
       it: the alternative is a button reading "הוסף לעגלה" while the
       subscription option is selected.

       Coalesced into one pass per frame, and applyCta only writes when the
       value actually changed. Both matter: the observer watches the same
       subtree applyCta writes to, so an eager or unconditional version feeds
       itself. */
    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; applyCta(); applyPrice(); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
